import React from 'react';
import { get } from 'lodash';
import { FormSectionTitle } from '../../../Components/Typography/Headlines';
import { SwitchFirm } from './SwitchFirm';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Typography } from '@material-ui/core';
import { FIRM_CLAIMED, FIRM_INACTIVE } from './ListSection';

const useStyles = makeStyles((theme) => ({
    fcaIDInput: {
        '& > .MuiOutlinedInput-adornedEnd': {
            paddingRight: '0',
        },
    },
    circularProgressContainer: {
        width: 0,
    },
    circularProgress: {
        top: '4px',
        left: '-40px',
        position: 'relative',
    },
    firmDetail: {
        marginBottom: '1.25rem',
        '& .MuiTypography-root': {
            margin: '0px',
        },
    },
    inactiveNote: {
        position: 'relative',
        top: '-1.25rem',
    },
}));

export default function FirmDetails({ record }) {
    const firm = get(record, 'firm', {});
    const firmVisibility = get(firm, 'firm_visibility');

    return (
        <>
            <div>
                <FormSectionTitle title={'Firm Details'}/>
                <FirmDetail label={'Firm Name:'} value={get(firm, 'name')}/>
                <FirmDetail label={'Firm FCA ID:'} value={get(firm, 'fca_number')}/>
                <FirmDetail
                    label={'Firm Profile Visibility:'} value={firmVisibility}
                    error={firmVisibility !== FIRM_CLAIMED}/>
                <FirmInactiveNote firmVisibility={firmVisibility}/>

                <SwitchFirm/>
                <br/>
                <FirmDetail
                    label={'Note: if your firm pays for your membership and you move firms you may lose access to VouhcedFor services or continue to be charged individually.'}/>
            </div>
        </>
    );
}

const FirmInactiveNote = ({ firmVisibility }) => {
    const classes = useStyles();

    if (firmVisibility !== FIRM_INACTIVE) {
        return null;
    }

    return (
        <Typography className={classes.inactiveNote}>
            Your firm profile is currently inactive, to undo this, please contact us at <a
            href={'mailto:customer_service@vouchedfor.co.uk'}>customer_service@vouchedfor.co.uk</a>.
        </Typography>
    );
};

const FirmDetail = ({ label, value, error = false }) => {
    const classes = useStyles();
    return (
        <Grid container direction={'column'} spacing={0} className={classes.firmDetail}>
            <Grid item>
                <Typography>{label}</Typography>
            </Grid>
            <Grid item>
                <Typography color={error ? 'error' : ''}><strong>{value}</strong></Typography>
            </Grid>
        </Grid>
    );
};